/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import AngeloneSetupBlog from '../pages/fno-blogs/AngeloneSetupBlog'
import LandingPage from '../pages/landing/LandingPage'
import PrivacyPolicy from '../pages/policy/PrivacyPolicy'
import TermsAndCondition from '../pages/policy/TermsAndCondition'
import RefundPolicy from '../pages/policy/RefundPolicy'
import UpstoxSetupBlog from '../pages/fno-blogs/UpstoxSetupBlog'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='angelone-demat-setup' element={<AngeloneSetupBlog />} />
          <Route path='upstox-demat-setup' element={<UpstoxSetupBlog />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsAndCondition />} />
          <Route path='/refund-policy' element={<RefundPolicy />} />

          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='/' element={<LandingPage />} />
              <Route path='login/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
